module.exports = __webpack_public_path__ + "static/media/home-background-img.fda6b8df.jpg";